import MasterStockList from "pages/report/master-stock/list"
import useMasterStockGlobalReportRepositories from "repositories/master-stock-global-report"

export default function List() {
  return (
    <MasterStockList
      title="Master Barang Global"
      description="Ringkasan stok barang per group atau product model pada tanggal yang dipilih."
      labelHeader="GROUP"
      endpoint="/reports/master-stock-global"
      useRepository={useMasterStockGlobalReportRepositories}
    />
  )
}
